
import { useTranslation } from 'react-i18next';

export default function TrustLegal() {
  const { t } = useTranslation();

  const trustPoints = [
    { icon: 'ri-shield-check-line', titleKey: 'trust.t1.title', descKey: 'trust.t1.desc' },
    { icon: 'ri-file-list-3-line', titleKey: 'trust.t2.title', descKey: 'trust.t2.desc' },
    { icon: 'ri-price-tag-3-line', titleKey: 'trust.t3.title', descKey: 'trust.t3.desc' },
    { icon: 'ri-refund-2-line', titleKey: 'trust.t4.title', descKey: 'trust.t4.desc' },
  ];

  // Guard against missing translation function
  if (!t) {
    console.error('useTranslation hook did not return a translation function.');
    return null;
  }

  return (
    <section className="py-20 relative">
      <div className="w-full bg-[#1a1a1a] border-t border-white/8 py-16">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {trustPoints.map((point, index) => (
              <div key={index} className="space-y-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${point.icon} text-2xl text-[#d4af37]`}></i>
                </div>
                <h3 className="text-base font-semibold text-white">{t(point.titleKey)}</h3>
                <p className="text-sm text-[#888888] leading-relaxed">{t(point.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
